export default "__VITE_ASSET__tj$3z3Hr__"